
export const SETTRIPLIST = "SETTRIPLIST";
export const SETTRIPDATA = "SETTRIPDATA";
export const SETCITYLIST = "SETCITYLIST";
export const SETCOUNTRYLIST = "SETCOUNTRYLIST";
export const SETAIRPORTLIST = "SETAIRPORTLIST";
export const SETSEATPREFERENCE = "SETSEATPREFERENCE";
export const SETCARTYPELIST = "SETCARTYPELIST";
export const SETMEALPREFERENCE = "SETMEALPREFERENCE";
export const SETFLIGHTPREFERENCE = "SETFLIGHTPREFERENCE";
export const SETBUSPREFERENCE = "SETBUSPREFERENCE";
export const SETBUSSEATPREFERENCE = "SETBUSSEATPREFERENCE";
export const SETTRIPBASICFILTERDATA = "SETTRIPBASICFILTERDATA";
export const CLEARDOC = "CLEARDOC";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const SETTRIPPOLICY = "SETTRIPPOLICY";
export const SETAPPROVALSTATUS = "SETAPPROVALSTATUS"; 